export const KycType = {
  VerifiedAccount: "verified-account",
  VerifiedTNVSAccount: "verified-tnvs",
}